import { Link } from '@solidjs/router';
import { styled } from 'solid-styled-components';
import theme, { fontFamilyAtosBold, fontFamilyAtosRegular } from '../../../../style/theme';

export const StyledMenuHeader = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 3rem 0 1rem 0;
`;

export const StyledMenuHeaderLinks = styled.div`
    gap: 1rem 3rem;
    display: flex;
    flex-wrap: wrap;
    margin: 1rem 0;
`;

export const StyledMenuHeaderLink = styled(Link)<StyledMenuHeaderLinkProps>`
    color: ${(p) => (p.active ? theme.palette.primary : theme.palette.gray)};
    text-transform: uppercase;
    text-decoration: ${(p) => (p.active ? 'underline' : 'none')};
    font-size: 1.29rem;
    letter-spacing: 0;
    line-height: 1.93rem;
    font-family: ${fontFamilyAtosBold};
    font-weight: 800;
    align-self: flex-start;
    &:hover {
        color: ${theme.palette.primaryHover};
    }
`;
type StyledMenuHeaderLinkProps = {
    active: boolean;
};

export const StyledMenuHeaderIconLinks = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 3.86rem;
`;

export const StyledDivider = styled.div`
    border-left: 1px solid ${theme.palette.gray};
    height: 2.86rem;
`;

export const StyledCloseButton = styled.button`
    background-color: ${theme.palette.gray};
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    border-radius: 0 0 0.71rem 0.71rem;
    gap: 1rem;
    align-items: flex-end;
    padding: 1rem;
    position: relative;
    top: -3.3rem;
    padding-top: 3rem;
`;

export const StyledCloseButtonText = styled.div`
    color: ${theme.palette.white};
    font-family: ${fontFamilyAtosRegular};
    font-size: 2.14rem;
    letter-spacing: -0.05rem;
    position: relative;
    top: 0.5rem;
`;

export const StyledMenuHeaderRight = styled.div`
    display: flex;
    gap: 1rem;
`;
